import produce from "immer";
import {
  DELETE_ROLE_FAILURE,
  DELETE_ROLE_PENDING,
  DELETE_ROLE_SUCCESS,
  GET_ROLES_FAILURE,
  GET_ROLES_PENDING,
  GET_ROLES_SUCCESS,
  ROLES_CLOSE_ADD_MODAL,
  ROLES_CLOSE_EDIT_MODAL,
  ROLES_CLOSE_VIEW_MODAL,
  ROLES_EDIT_MODAL_OPEN_AND_FETCH,
  ROLES_MODAL_SET_ROLE,
  ROLES_OPEN_ADD_MODAL,
  ROLES_VIEW_MODAL_OPEN_AND_FETCH,
  ROLES_VIEW_MODEL_START_FETCH,
  ROLE_EDIT_FAILURE,
  ROLE_EDIT_PENDING,
  ROLE_EDIT_SUCCESS,
  ROLE_SAVE_FAILURE,
  ROLE_SAVE_PENDING,
  ROLE_SAVE_SUCCESS,
} from "./constants";

const initialState = {
  isRolesLoading: false,
  roles: [],
  error: null,
  isRoleSaving: false,
  saveError: null,
  reloadRoles: false,
  isViewModalOpen: false,
  isRoleDeleting: false,
  deleteError: null,
  doOpen: true,
};
const RoleReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ROLES_PENDING:
        draft.isRolesLoading = true;
        draft.isRoleSaving = false;
        draft.reloadRoles = false;
        break;
      case GET_ROLES_SUCCESS:
        draft.roles = action.payload;
        draft.isRolesLoading = false;
        break;
      case GET_ROLES_FAILURE:
        draft.error = action.payload.error;
        draft.isRolesLoading = false;
        break;
      case ROLES_OPEN_ADD_MODAL:
        draft.isAddModalOpen = true;
        draft.currentRole = {};
        draft.isRolesLoading = false;
        break;
      case ROLES_CLOSE_ADD_MODAL:
        draft.isAddModalOpen = false;
        break;
      case ROLES_VIEW_MODAL_OPEN_AND_FETCH:
        draft.isFetching = true;
        draft.isViewModalOpen = true;
        draft.isRoleSaving = true;
        break;
      case ROLES_MODAL_SET_ROLE:
        draft.isFetching = false;
        draft.currentRole = action.payload;
        draft.isRoleSaving = false;
        break;
      case ROLES_CLOSE_VIEW_MODAL:
        draft.isRolesLoading = false;
        draft.isViewModalOpen = false;
        break;
      case ROLES_EDIT_MODAL_OPEN_AND_FETCH:
        draft.isEditing = true;
        draft.isRoleSaving = true;
        draft.isFetching = true;
        draft.isEditModalOpen = true;
        break;
      case ROLES_VIEW_MODEL_START_FETCH:
        draft.isFetching = true;
        draft.isViewModalOpen = true;
        draft.isRolesLoading = false;
        break;

      //Save Roles
      case ROLE_SAVE_PENDING:
        draft.isRoleSaving = true;
        draft.saveError = null;
        break;
      case ROLE_SAVE_SUCCESS:
        draft.isRoleSaving = false;
        draft.message = action.payload.message;
        draft.saveError = null;
        draft.reloadRoles = true;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        break;
      case ROLE_SAVE_FAILURE:
        draft.isRoleSaving = false;
        draft.saveError = action.payload.error;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        break;

      //EDIT ROLES
      case ROLE_EDIT_PENDING:
        draft.isRoleSaving = true;
        draft.saveError = null;
        break;
      case ROLE_EDIT_SUCCESS:
        draft.isRoleSaving = false;
        draft.message = action.payload.message;
        draft.saveError = null;
        draft.reloadRoles = true;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        break;
      case ROLE_EDIT_FAILURE:
        draft.isRoleSaving = false;
        draft.saveError = action.payload.error;
        draft.isEditing = false;
        draft.isFetching = false;
        draft.isEditModalOpen = false;
        break;
      case ROLES_CLOSE_EDIT_MODAL:
        draft.isEditing = false;
        draft.isEditModalOpen = false;
        break;

      //
      case DELETE_ROLE_PENDING:
        draft.isRoleDeleting = action.payload.isUserDeleting;
        draft.deleteError = null;
        draft.doOpen = true;
        break;
      case DELETE_ROLE_SUCCESS:
        draft.isRoleDeleting = false;
        draft.message = action.payload.message;
        draft.deleteError = null;
        draft.doOpen = false;
        draft.reloadRoles = true;
        break;
      case DELETE_ROLE_FAILURE:
        draft.isRoleDeleting = false;
        draft.deleteError = action.payload.error;
        draft.doOpen = false;
        break;
      default:
        return state;
    }
  });
};
export default RoleReducer;
